var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 3.33268C5.94496 3.33268 3.33329 5.94435 3.33329 9.16602C3.33329 12.3877 5.94496 14.9993 9.16663 14.9993C10.7382 14.9993 12.1647 14.3778 13.2136 13.3672C13.2355 13.3386 13.2596 13.3112 13.2857 13.2851C13.3118 13.259 13.3393 13.2349 13.3678 13.213C14.3784 12.1641 15 10.7376 15 9.16602C15 5.94435 12.3883 3.33268 9.16663 3.33268ZM15.0265 13.8474C16.0529 12.5644 16.6666 10.9369 16.6666 9.16602C16.6666 5.02388 13.3088 1.66602 9.16663 1.66602C5.02449 1.66602 1.66663 5.02388 1.66663 9.16602C1.66663 13.3082 5.02449 16.666 9.16663 16.666C10.9375 16.666 12.565 16.0523 13.848 15.0259L16.9107 18.0886C17.2361 18.414 17.7638 18.414 18.0892 18.0886C18.4147 17.7632 18.4147 17.2355 18.0892 16.9101L15.0265 13.8474Z",
    fill: "#7A7879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.980c746c71ef6ff05ea8d641eb0fda39.svg";
export { ForwardRef as ReactComponent };